<div class="actionwrapper">
  <div class="actions">
    <button mat-raised-button color="primary" (click)="addItem()">
      <mat-icon>add</mat-icon>
      Add New Vendor Config
    </button>
  </div>
</div>
<table class="table" mat-table matSort [dataSource]="items">
  <ng-container matColumnDef="vendorSlug">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Vendor slug</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.vendorSlug}}</td>
  </ng-container>
  <ng-container matColumnDef="adapterType">
    <th mat-header-cell *matHeaderCellDef>Adapter</th>
    <td class="cell" mat-cell *matCellDef="let item">{{getAdapterTypeLabel(item)}}</td>
  </ng-container>
  <ng-container matColumnDef="credentialConfiguration">
    <th mat-header-cell *matHeaderCellDef>Credential status</th>
    <td class="cell" mat-cell *matCellDef="let item">{{getCredentialStatusLabel(item)}}</td>
  </ng-container>
  <ng-container matColumnDef="requiredFields">
    <th mat-header-cell *matHeaderCellDef>Required fields</th>
    <td class="cell required-fields-cell" mat-cell *matCellDef="let item">
      @if (getRequiredFieldSections(item); as sections) {
        @if (sections.length) {
          @for (section of sections; track section.label) {
            <div class="required-field-section">
              <span class="required-field-label">{{section.label}}:</span>
              <span>{{section.values.join(', ')}}</span>
            </div>
          }
        } @else {
          <span class="empty-required-fields">None</span>
        }
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="actionmenu" stickyEnd>
    <th mat-header-cell matTooltip="Actions" *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let item"><button mat-button class="cell" [matMenuTriggerFor]="menu" [matMenuTriggerData]="{item: item}"><mat-icon matTooltip="Actions" class="more">more_vert</mat-icon></button></td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="allColumnNames"></tr>
  <tr class="listitem" mat-row *matRowDef="let rows; columns: allColumnNames"></tr>
  <mat-menu #menu="matMenu">
    <ng-template matMenuContent let-item="item">
      @if (canEditVendor(item)) {
        <button mat-menu-item (click)="editItem(item)">Edit</button>
      }
      @if (canCloneVendor(item)) {
        <button mat-menu-item (click)="addItem(item)">Clone</button>
      }
      @if (canDeleteVendor(item)) {
        <button mat-menu-item (click)="deleteItem(item)">Delete</button>
      }
      <mat-divider></mat-divider>
      @if (hasVendorSchedule(item, 'enroll')) {
        <button mat-menu-item (click)="runScheduleNow(item, 'enroll')">Run Enroll Schedule Now</button>
      }
      @if (hasVendorSchedule(item, 'payment')) {
        <button mat-menu-item (click)="runScheduleNow(item, 'payment')">Run Payment Schedule Now</button>
      }
      <button mat-menu-item (click)="rerunCarrierIntegration(item)">Rerun Carrier Integration</button>
    </ng-template>
  </mat-menu>
</table>
